import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=89be979c&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports